export const formValuesToApi = (formValues) => {
  return formValues.videos;
};
